export default __webpack_public_path__ + "static/media/edited-mobile.043ad49c.jpg";